function strongPasswordTooltip () {
  return {
    restrict: 'E',
    scope: {
      passwordRules: '<'
    },
    templateUrl: '/auth/directives/strong-password-tooltip/strong-password-tooltip-directive.html?$$REVISION$$'
  }
}

export { strongPasswordTooltip }
